import styled, { keyframes } from 'styled-components'

import {
  fonts,
  mediaQueries,
  palette,
  setOpacity,
} from '../../styles/variables'
import ReturnRight from '../../styles/assets/tableIcons/right_arrow.svg'
import ReturnRightHover from '../../styles/assets/tableIcons/right_arrow_hover.svg'
import { ReactComponent as ArrowRightSVG } from '../../styles/assets/arrows/plan_arrow_right.svg'

const Icon = styled.img((props) => ({
  width: props.width || props.size,
  height: props.height || props.size,
  margin: props.margin || 0,
  transform: props.transform || 'translateX(0)',
  [mediaQueries.mobile]: {
    transform: 'translateX(0)',
  },
}))

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`

export const SpiningIcon = styled.img`
  width: ${(props) => props.width || props.size};
  height: ${(props) => props.height || props.size};
  margin: ${(props) => props.margin || 0};
  transform: ${(props) => props.transform || 'translateX(0)'};
  animation: ${spin} 2s linear infinite;
`

export const Cross = styled.span((props) => ({
  position: props?.position || 'relative',
  width: props?.width || '14px',
  height: props?.height || '14px',
  cursor: 'pointer',
  margin: props?.margin || '0 20px 0 0',
  ':hover::before,:hover::after': {
    background: props?.hoverColor || palette.orange,
  },
  ':before,:after': {
    content: `''`,
    position: 'absolute',
    width: '100%',
    top: '50%',
    height: props?.strokeWidth || '1px',
    background: props.color || palette.darkGray,
    transform: 'rotate(45deg)',
  },
  ':after': {
    transform: 'rotate(-45deg)',
  },
}))

export const Line = styled.div((props) => ({
  borderTop: `1px solid ${props.color || palette.lightGray50}`,
  width: props.width || '100%',
  margin: props.margin || '0 -10px',
  paddingTop: '20px',
  [mediaQueries.mobile]: {
    margin: props.margin || '0 -10px',
  },
}))

export const VerticalLine = styled.div((props) => ({
  width: props.width || '1px',
  height: props.height || '100%',
  backgroundColor: props.color || palette.lightGray,
}))

export const LinkIcon = ({ src, href }) => (
  <a href={href} target="_blank" rel="noopener noreferrer">
    <Icon src={src} size="11px" margin="0 5px 0 0" />
  </a>
)

export const LinkIconButton = ({ src, style, ...rest }) => (
  <button type="submit" style={{ padding: 0, border: 0, ...style }} {...rest}>
    <Icon src={src} size="11px" margin="0 5px 0 0" />
  </button>
)

export const ImagePreloader = styled.div({
  position: 'absolute',
  width: 0,
  height: 0,
  x: '-99999px',
  y: '-99999px',
  overflow: 'hidden',
  zIndex: -1,
  content: `url(${ReturnRightHover}) url(${ReturnRight})`,
})

export const ReturnRightIcon = styled.span((props) => ({
  width: '22px',
  height: '20px',
  minWidth: '22px',
  margin: props.margin || 0,
  backgroundImage: props.active
    ? `url(${ReturnRightHover})`
    : `url(${ReturnRight})`,
  [mediaQueries.mobile]: {
    display: 'none',
  },
}))

export const CheckIcon = styled.div((props) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '24px',
  height: '24px',
  borderRadius: props.circled ? '12px' : 0,
  background: setOpacity(palette.success, 0.5),
  ':before': {
    content: `''`,
    width: '5px',
    height: '10px',
    borderRight: `2px solid ${palette.darkGreen}`,
    borderBottom: `2px solid ${palette.darkGreen}`,
    transform: 'rotate(45deg)',
    marginTop: '-2px',
  },
}))

export const CrossIcon = styled.div((props) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '24px',
  height: '24px',
  borderRadius: props.circled ? '12px' : 0,
  background: palette.red,
  ':before': {
    content: `''`,
    borderLeft: `1px solid ${palette.white}`,
    height: '16px',
    transform: 'rotate(45deg)',
  },
  ':after': {
    content: `''`,
    borderLeft: `1px solid ${palette.white}`,
    height: '16px',
    transform: 'rotate(-45deg)',
    marginLeft: '-1px',
  },
}))

export const ArrowLabel = styled.div((props) => {
  let borderTopColor = palette.red
  if (props.isZero) borderTopColor = palette.gray
  if (props.up) borderTopColor = palette.green
  return {
    display: 'flex',
    alignItems: 'baseline',
    fontSize: props.small ? '11px' : '14px',
    lineHeight: '18px',
    ':before': {
      content: `''`,
      borderLeft: '7px solid transparent',
      borderRight: '7px solid transparent',
      borderTop: `10px solid ${borderTopColor}`,
      transform: props.up ? 'rotate(180deg)' : 'none',
      marginRight: '4px',
      [mediaQueries.mobile]: {
        borderLeft: '5px solid transparent',
        borderRight: '5px solid transparent',
        borderTop: `10px solid ${borderTopColor}`,
        transform: props.up ? 'rotate(180deg)' : 'none',
      },
    },
    [mediaQueries.mobile]: {
      fontSize: props.small ? '11px' : '14px',
    },
  }
})

const composeTransform = (props) => {
  if (props.up) return 'translate(6px, 1px) rotate(135deg)'
  if (props.down) return 'translate(6px, -3px) rotate(-45deg)'
  if (props.left) return 'translate(6px, -1px) rotate(45deg)'
  return 'translate(6px, -1px) rotate(-135deg)' // right
}

// up down left right icon
export const ArrowIcon = styled.span((props) => ({
  display: 'inline-block',
  width: '7px',
  height: '7px',
  border: '0',
  padding: '0',
  marginLeft: '5px',
  backgroundColor: 'transparent',
  borderLeft: props.color
    ? `${props.width ? props.width : '1px'} solid ${props.color}`
    : `${props.width ? props.width : '1px'} solid white`,
  borderBottom: props.color
    ? `${props.width ? props.width : '1px'} solid ${props.color}`
    : `${props.width ? props.width : '1px'} solid white`,
  transform: composeTransform(props),
}))

export const NavArrowIcon = styled.span((props) => ({
  display: 'inline-block',
  width: '7px',
  height: '7px',
  border: '0',
  padding: '0',
  marginLeft: '5px',
  backgroundColor: 'transparent',
  borderLeft: props.color ? `2px solid ${props.color}` : '2px solid white',
  borderBottom: props.color ? `2px solid ${props.color}` : '2px solid white',
  transform: composeTransform(props),
  transition: 'transform .3s ease, border-color .3s ease',
}))

// checkmark
export const CheckMark = styled.span((props) => ({
  height: '7px',
  width: '14px',
  backgroundColor: 'transparent',
  borderLeft: props.color ? `2px solid ${props.color}` : '1px solid white',
  borderBottom: props.color ? `2px solid ${props.color}` : '1px solid white',
  transform: 'translate(6px, -2px) rotate(-45deg)',
  [mediaQueries.mobile]: {
    display: props.mobileDisplay || 'inline-block',
  },
}))

// arrow right icon
export const ArrowRightIcon = ({ className = '' }) => (
  <ArrowRightSVG className={className} />
)

const colors = [
  palette.red,
  palette.pink,
  palette.lightBlue,
  palette.brightOrange,
  palette.green,
  palette.warning,
  palette.info,
  palette.orange,
  palette.gray,
  palette.darkGreen,
  palette.blue,
  palette.darkYellow,
  palette.dullGreen,
  palette.limeYellow,
  palette.darkRed,
]

const colorsDuplicated = Array.from({ length: 5 }, () => colors).flat()

export const DomainIcon = styled.span((props) => ({
  width: 16,
  height: 16,
  minWidth: 16,
  display: 'inline-flex',
  backgroundColor: setOpacity(colorsDuplicated[props.colorIndex], 0.4),
  border: `1px solid ${colorsDuplicated[props.colorIndex]}`,
  color: palette.darkGray,
  borderRadius: 8,
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '12px',
  lineHeight: '12px',
  paddingTop: '2px',
}))

export const BetaTag = styled.div({
  width: 'fit-content',
  borderRadius: '20px',
  padding: '7px 5px 5px 5px',
  color: palette.white,
  backgroundColor: palette.blue,
  fontSize: '10px',
  lineHeight: '8px',
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  fontFamily: fonts.primaryMedium,
  display: 'inline-block',
  marginLeft: '8px',
  cursor: 'pointer',
})

const IconCircle = styled.div((props) => ({
  width: props.size,
  height: props.size,
  background: props.background || palette.lightGray20,
  borderRadius: props.size / 2,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  [mediaQueries.mobile]: {
    width: props.mobileSize,
    height: props.mobileSize,
  },
  ...(props.styles || {}),
}))

export const IconInCircle = ({
  background,
  icon,
  size,
  mobileSize,
  ...rest
}) => {
  return (
    <IconCircle
      background={background}
      size={size}
      mobileSize={mobileSize || size}
      {...rest}
    >
      <Icon src={icon} />
    </IconCircle>
  )
}

export default Icon
